import { Stack } from '@mui/material';

import { Notification } from './Notification';
import { INotificationsContainerProps } from './types';

export const NotificationsContainer = ({
  notifications,
  deleteNotification,
}: INotificationsContainerProps) => {
  return (
    <Stack spacing={2} sx={{ maxWidth: 600 }}>
      {notifications.map((notification) => {
        return (
          <Notification
            key={notification.id}
            onRemove={deleteNotification}
            {...notification}
          />
        );
      })}
    </Stack>
  );
};
